import { render, staticRenderFns } from "./WhereToDownloadApp.vue?vue&type=template&id=6d1541af&scoped=true&"
import script from "./WhereToDownloadApp.vue?vue&type=script&lang=js&"
export * from "./WhereToDownloadApp.vue?vue&type=script&lang=js&"
import style0 from "./WhereToDownloadApp.vue?vue&type=style&index=0&id=6d1541af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1541af",
  null
  
)

export default component.exports